import { ArticleHeading3, ArticleHeading5, useDeviceType } from '@cian/ui-kit';
import * as style from './Footer.css';
import { Socials } from '../Socials';
import { clsx } from 'clsx';

export const Footer: React.FC = () => {
  const device = useDeviceType();

  const ArtHeading = device !== 'desktop' ? ArticleHeading5 : ArticleHeading3;

  return (
    <div
      className={clsx(
        style['container'],
        device === 'tablet' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['wrapper']}>
        <div className={style['doc-links']}>
          <div className={style['title']}>
            <ArtHeading color="white_100">Документы</ArtHeading>
          </div>
          <a href="https://pik-arenda.ru/assets/uploads/agreement_insurance.pdf" target="_blank" rel="noreferrer">
            <ArtHeading color="white_100">Договор аренды ПИК-Аренда</ArtHeading>
          </a>
          <a href="https://lk.pik-arenda.ru/agreement/agreement.pdf" target="_blank" rel="noreferrer">
            <ArtHeading color="white_100">Пользовательское соглашение ПИК-Аренда</ArtHeading>
          </a>
        </div>
        <div className={style['social-links']}>
          <Socials theme="white" />
        </div>
      </div>
    </div>
  );
};
